import React from 'react';
import { motion } from 'framer-motion';
import { useModal } from '../services/ModalService';
import '../styles/pages/About.css';

const About = () => {
  const { openContactModal } = useModal();

  return (
    <div className="about">
      {/* Hero Section */}
      <section style={{
        minHeight: "60vh",
        display: "flex", 
        alignItems: "center",
        position: "relative",
        background: "linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(167, 85, 247, 0.1) 100%)",
        paddingTop: "120px"
      }}>
        <div className="about-container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            style={{ textAlign: "center" }}
          >
            <div className="hero-badge">
              🚀 About RKube Inc
            </div>
            
            <h1 className="hero-title"
            dangerouslySetInnerHTML={{ __html: "Empowering Businesses Through <span class=\"gradient-text\">Innovation</span><br />and Excellence" }}
            />
            
            <p className="hero-subtitle">
              Empowering businesses through innovative BPO services and cutting-edge technology solutions
            </p>
            
            <div className="hero-buttons">
              <button 
                className="btn-primary"
                onClick={() => openContactModal(
                  'About Company Information',
                  'About Page - Learn About Our Mission'
                )}
              >
                Learn About Our Mission
              </button>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="about-section">
        <div className="about-container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <p className="about-section-subtitle">
              Leading the way in business process outsourcing and technology innovation
            </p>
            
            <div className="about-services-grid">
              <div className="about-glass-card">
                <h3>Our Mission</h3>
                <p>To provide exceptional business process outsourcing services and innovative IT solutions that drive efficiency, growth, and success for our clients worldwide.</p>
              </div>
              
              <div className="about-glass-card">
                <h3>Our Vision</h3>
                <p>To be the leading global partner for businesses seeking comprehensive BPO services and technology solutions that transform operations and accelerate growth.</p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Values Section */}
      <section className="about-section">
        <div className="about-container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <p className="about-section-subtitle">
              Why businesses worldwide trust us with their most critical operations
            </p>
            
            <div className="about-services-grid">
              <div className="about-glass-card">
                <h3>🏆 Industry Expertise</h3>
                <p>Over 10 years of experience in BPO services and IT solutions</p>
              </div>
              
              <div className="about-glass-card">
                <h3>🔒 Data Security</h3>
                <p>Enterprise-grade security measures to protect your sensitive information</p>
              </div>
              
              <div className="about-glass-card">
                <h3>⚡ Fast Delivery</h3>
                <p>Quick turnaround times without compromising on quality</p>
              </div>
              
              <div className="about-glass-card">
                <h3>🌍 Global Reach</h3>
                <p>Serving clients across multiple countries and time zones</p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default About;